/**
 * Hook to check whether the Rovo Insights feature is available for the current user.
 */
import { useQuery } from '@atlassian/conversation-assistant-service/common/utils/use-query';
import {
	type AssistanceServiceInjectedParams,
	type AssistanceServiceInputParam,
	createHookWithAssistanceService,
} from '@atlassian/conversation-assistant-service/services/assistance-service/main';

export interface UseInsightsStatusResult {
	isInsightsAvailable: boolean;
	isLoading: boolean;
}

interface UseInsightsStatusProps extends AssistanceServiceInjectedParams {
	enabled: boolean;
}

export const useInsightsStatus: (
	props: Omit<UseInsightsStatusProps, 'assistanceServiceInjectedParams'> &
		AssistanceServiceInputParam,
) => UseInsightsStatusResult = createHookWithAssistanceService(
	({ assistanceServiceInjectedParams: { assistanceService }, enabled }: UseInsightsStatusProps) => {
		const { data, isFetching } = useQuery<{ insights_available: boolean }>({
			queryKey: ['insightsStatus'],
			enabled,
			queryFn: async () => {
				return assistanceService.getInsightsStatus();
			},
		});

		return {
			isInsightsAvailable: Boolean(data?.insights_available),
			isLoading: isFetching && data === null,
		};
	},
);
